<!-- eslint-disable -->
<template lang="pug">
    .detective-banner(
        :class=`[
            isAnimated && 'detective-banner--animated',
        ]`,
        @mouseover="stopInterval",
        @mouseout="startInterval",
    )
        template(v-if="!isLoading")
            .detective-banner__current-place
                .detective-banner__image(:style="bannerStyle")
            .detective-banner__info
                .detective-banner__header
                    |  {{ $i18n.t('dashboard.dashboard_detective_headerTitle') }}
                .detective-banner__text
                    template(v-if="isIntroduction && stage && stage.id !== 3")
                        |	{{ $i18n.t('dashboard.dashboard_detective_introduction') }}
                    template(v-else-if="stage && !stage.isCompleted && stage.id !== 3")
                        span(v-if="item && item.isBought")
                            | {{ $i18n.t('dashboard.dashboard_detective_location') }}
                            | {{ $i18n.t('detectiveModal.cases.accusative')[sceneName] }}!
                        template(v-if="nextItem")
                            template(v-if="isEnoughPoints")
                                | {{ $i18n.t('dashboard.dashboard_detective_enoughPoints') }}!
                            template(v-else)
                                span(v-html="$i18n.t('dashboard.dashboard_detective_notEnoughPointsTakeMore',\
                                            {'value': '<strong>' + (nextItemPrice - points) + '</strong>'})"
                                )
                                | !
                        div(v-else)
                            | {{ $i18n.t('dashboard.dashboard_detective_finishedStage') }}
                .detective-banner__button
                    cs-button(
                        v-if="sceneName === 'Introduction'"
                        color="blue"
                        @click="$router.push({name: 'detective', params: { modal: true} })"
                    )
                        | {{ $i18n.t('dashboard.dashboard_detective_introductionStart') }}
                    template(v-else)
                        cs-button(
                            v-if="'eighthLetter' !== sceneName && isEnoughPoints && stage && stage.id !== 3"
                            color="blue"
                            @click="$router.push({name: 'detective', params: { modal: true }})"
                        )
                            | {{ $i18n.t('dashboard.dashboard_map_goNext') }}
                        template(v-else)
                            progress.detective-banner__progress(
                                v-if="'eighthLetter' !== sceneName && stage && stage.id !== 3"
                                :value="points"
                                :max="nextItemPrice"
                            )
                            cs-button(
                                color="blue"
                                @click="$router.push({name: 'detective'})"
                            )
                                | {{ $i18n.t('dashboard.dashboard_detective_headerAction') }}
        cs-loader(v-else="")
</template>

<script>
    /*eslint-disable*/
    import { mapState } from 'vuex'
    import motivationApi from '../../../api/motivation/motivationApi'

    const MOTIVATION_TYPE = 'detective';

    export default {
        data () {
            return {
                isLoading: false,
                isAnimated: false,
                animateInterval: null,
                sceneId: 0,
                sceneName: "",
                stages: null,
                scenes: [],
                points: 0,
                stage: null,
                data: null,
                isButtonLoading: false,
                isIntroduction: true,
                item: null,
                nextItem: null,
                nextItemPrice: 0,
            };
        },
        mounted () {
            this.fetchData();
            this.isIntroduction && this.startInterval()
        },
        methods: {
            fetchData () {
                this.isLoading = true;
                motivationApi.show(this.user.id, MOTIVATION_TYPE)
                .then((motivation) => {
                    this.setData(motivation);
                    this.isLoading = false;
                }).catch(e => {
                    this.isLoading = false;
                    this.showErrorMessage(e)
                });
            },
            setData (motivation) {
                this.data = JSON.parse(motivation.data);
                this.points = this.data.points;
                this.stages = this.data.stages;
                for(let stage of this.stages) {
                    let item = stage.items.find(item => !item.isBought);
                    if (item) {
                        let id = stage.id - 1;
                        if(this.isSkipThingOrWord(id, item)) {
                            this.stages[id].isCompleted = false;
                            this.stages[id].scene = item.id > 0 ? item.id - 1 : 0;
                            break;
                        }
                    }
                }
                this.stage = this.stages.find(stage => !stage.isCompleted);
                this.isIntroduction = _.cloneDeep(this.stage.isIntroduction);
                //TODO: delete this if, when all stages will be written
                if (this.stage.id === 3) {
                    return;
                }
                this.item = this.stage.items.find(item => item.id === this.stage.scene);
                this.nextItem = this.stage.items.find(item => !item.isBought);
                this.nextItemPrice = this.nextItem ? this.nextItem.price : 0;
                this.scenes = this.$i18n.t(`detectiveStoryConversations.${this.stage.id}`);
                this.sceneId = (this.item && this.item.isBought || this.isIntroduction) ? this.stage.scene : this.stage.scene - 1;
                this.sceneName = this.scenes[this.sceneId].name;
            },
            showErrorMessage (err) {
                if (err.data) {
                    this.$toasted.error(err.data.message);
                    this.$router.push({ name: 'dashboard' });
                }
                err = (err.response && err.response.data) ? err.response.data : err;
                if (err && (err.status_code === 403 || err.status_code === 404)) {
                    this.$router.push({ name: 'dashboard' });
                    this.$toasted.error(err.message);
                }
            },
            startInterval () {
                this.isIntroduction && (this.animateInterval = setInterval(() => {
                    this.isAnimated = !this.isAnimated;
                }, 600))
            },
            stopInterval () {
                if (this.animateInterval) {
                    clearInterval(this.animateInterval);
                    this.isAnimated = false;
                }
            },
            isSkipThingOrWord (id, item) {
                return item.id < this.stages[id].scene || (this.stages[id].scene - item.id) > 1;
            },
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
            }),
            isEnoughPoints () {
                return this.points >= this.nextItemPrice || this.stage.scene === (this.nextItem && this.nextItem.id);
            },
            previewImage () {
                if (this.stage && this.sceneName && !this.isIntroduction) {
                    if (this.stage.id === 1) {
                        return '/imgs/items/' + this.sceneName.toLowerCase() + '/' + this.sceneName.toLowerCase() + '.svg'
                    } else if (this.stage.id === 2) {
                        return '/imgs/letters/' + this.sceneName.split("Letter")[0] + '.png';
                    }
                }
                return '/imgs/items/introduction/introduction.png';
            },
            bannerStyle () {
                const backgroundSize = this.stage && this.stage.id === 2 ? '50px' : 'contain';
                return {
                    background: `url(${this.previewImage}) center center / ${backgroundSize} no-repeat`,
                    height: '220px',
                };
            },
        }
    }
</script>

<style lang="scss" scoped>
    .detective-banner {
        box-sizing: border-box;
        background-color: $hsl-color-gray-98;
        border-radius: $border-radius-20;

        display: flex;
        flex-direction: column;
        justify-content: space-between;

        transition: transform 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);

        &:not(last-child) {
            margin-bottom: 30px;
        }
    }

    .detective-banner--animated {
        transform: scale(1.05, 1.05);
    }

    .detective-banner__header {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
    }

    .detective-banner__text {
        margin-top: 10px;
        font-size: 16px;
        line-height: 24px;
    }

    .detective-banner__button {
        margin-top: 13px;
    }

    .detective-banner__current-place {
        margin: 30px auto;
        width: 220px;
        height: 220px;
        background-color: $x-color-white;
        border-radius: $border-radius-circle;
    }

    .detective-banner__info {
        margin: 0 30px 30px;
    }

    .detective-banner__progress {
        margin-bottom: 20px;

        appearance: none;
        border: none;

        width: 100%;

        color: $hsl-color-green-58;
        background-color: $hsl-color-gray-92;
        border-radius: $border-radius-20;

        &::-webkit-progress-bar {
            background-color: $hsl-color-gray-92;
            border-radius: $border-radius-20;
        }

        &::-webkit-progress-value {
            background-color: $hsl-color-green-58;
            border-radius: $border-radius-20;
        }

        &::-moz-progress-bar {
            background-color: $hsl-color-green-58;
            border-radius: $border-radius-20;
        }
    }

</style>
